import React, { useEffect, useState } from 'react'
import { AiOutlinePlusCircle, AiOutlineDelete, AiOutlineEdit } from 'react-icons/ai';
import Select from 'react-select';
import { useNavigate } from 'react-router-dom';
import { IoArrowBack } from "react-icons/io5";
import axios from 'axios';
import logo from '../../../../assets/logo.png';
import ToastNotification from '../../../../components/ToastNotification';
import { useLoading } from '../../../../context/LoadingContext';
import ConfirmDialog from '../../../../components/ConfirmDialog';


const DisciplinaryWarning = () => {

    const navigate = useNavigate();
    const { setLoading } = useLoading();
    // ====================useStates=========================
    const [selectedPrint, setSelectedPrint] = useState(null);
    const [editingId, setEditingId] = useState(null);
    const [isEditing, setIsEditing] = useState(false);
    const [disciplinaryWarningList, setDisciplinaryWarningList] = useState([]);
    const [showForm, setShowForm] = useState(false);
    const [searchTerm, setSearchTerm] = useState('');
    const [employeeList, setEmployeeList] = useState([]);
    const [toast, setToast] = useState({
        show: false,
        message: '',
        bg: 'success'
    });
    const [confirmDialog, setConfirmDialog] = useState({
        show: false,
        title: '',
        message: '',
        onConfirm: null,
    });
    const getTodayDate = () => {
        const today = new Date();
        return today.toISOString().split('T')[0];
    }
    const [formData, setFormData] = useState({
        emp_db_id: '',
        from_date: getTodayDate(),
        doc_type: 'Disciplinary Warning',
        amount: '',
        prefix: 'HR',
        sufix: 'DSCP',
        effect: 'deduction',
        warning_description: ''
    })

    const effectOption = [
        { value: "none", label: "None" },
        { value: "earning", label: "Earning" },
        { value: "deduction", label: "Deduction" }
    ]

    // =================handlers=======================
    const showToast = (message, bg = 'success') => {
        setToast({ show: true, message, bg });
    };
    const showConfirmDialog = ({ title, message, onConfirm }) => {
        setConfirmDialog({
            show: true,
            title,
            message,
            onConfirm: () => {
                onConfirm();
                setConfirmDialog({ ...confirmDialog, show: false });
            },
        });
    };


    const filteredData = disciplinaryWarningList.filter(itm =>
        Object.values(itm).some(val =>
            String(val).toLowerCase().includes(searchTerm.toLowerCase())
        )
    )

    const handleFormOpen = () => {
        setShowForm(true);
    }

    const resetForm = () => {
        setFormData({
            emp_db_id: "",
            from_date: getTodayDate(),
            doc_type: "Disciplinary Warning",
            amount: "",
            prefix: "HR",
            sufix: "DSCP",
            effect: "deduction",
            warning_description: ''
        });

        setShowForm(false);
        setIsEditing(false);
        setEditingId(null);
    }

    const handleSubmit = async (e) => {
        e.preventDefault();

        try {
            const payload = {
                ...formData,
                amount: formData.amount === '' ? null : formData.amount
            };

            if (isEditing) {
                const res = await axios.put(`https://api.skyguard.group/api/update-hrms-documents/${editingId}`, payload);
                // console.log("Server response", res.data.message);
                showToast('Disciplinary Warning Updated Successfully', 'success');

                setDisciplinaryWarningList(prev =>
                    prev.map(itm => itm.id === editingId ? { id: editingId, ...formData } : itm)
                );

            } else {
                const res = await axios.post('https://api.skyguard.group/api/add-hrms-documents', payload);

                showToast('Disciplinary Warning added successfully', 'success');
                setDisciplinaryWarningList(prev => [
                    ...prev,
                    { id: res.data.insertId, ...formData }
                ]);
            }
            fetchDisciplinaryWarning();
            resetForm();

        } catch (error) {
            console.error(error);
            showToast('Error Adding Disciplinary Warning', 'danger');
        }

    }

    const handleChange = (e) => {
        const { name, value } = e.target;

        setFormData(prev => ({
            ...prev,
            [name]: value
        }))
    }

    const handlePrint = (row) => {
        const empFull = employeeList.find(e => e.value === row.emp_id);

        const merged = {
            ...row,
            address: empFull?.address || "",
            city: empFull?.city || "",
            state: empFull?.state || "",
            pin: empFull?.pin || "",
            emp_name: empFull?.empName || row.emp_name
        };

        setSelectedPrint(merged);

        setTimeout(() => {
            const printContent = document.getElementById("print-area").innerHTML;
            const printWindow = window.open("", "", "width=900,height=650");
            printWindow.document.write(printContent);
            printWindow.document.close();
            printWindow.print();
        }, 300);
    };


    const handleEdit = (id) => {
        const data = disciplinaryWarningList.find(item => item.id === id);

        setFormData({
            emp_db_id: data.emp_db_id || '',
            from_date: data.from_date ? data.from_date.split('T')[0] : getTodayDate(),
            doc_type: data.doc_type || 'Disciplinary Warning',
            amount: data.amount || '',
            prefix: data.prefix || 'HR',
            sufix: data.sufix || 'DSCP',
            effect: data.effect || 'deduction',
            warning_description: data.warning_description || ''
        })

        setEditingId(id);
        setIsEditing(true);
        setShowForm(true);
    }

    const handleDelete = async (id) => {
        try {
            await axios.delete(`https://api.skyguard.group/api/delete-hrms-documents/${id}`);
            showToast('Disciplinary Warning deleted successfully', 'success');
            fetchDisciplinaryWarning();
            setDisciplinaryWarningList(prev => prev.filter(item => item.id !== id));

            if (isEditing && editingId === id) resetForm();
        } catch (error) {
            console.error('Error deleting Disciplinary Warning:', error);
            showToast('Failed to delete Disciplinary Warning', 'danger');
        }
    }

    //  ========================apis=========================

    const fetchEmployeeData = async () => {
        try {
            const res = await axios.get('https://api.skyguard.group/api/fetch-employee');
            const data = res.data.result;
            console.log(data);

            const formatted = data.map(emp => {
                const first = (emp.first || '').trim();
                const middle = (emp.middle || '').trim();
                const last = (emp.last || '').trim();

                const fullName = [first, middle, last].filter(Boolean).join(' ');
                return {
                    id: emp.id,
                    value: emp.emp_id,
                    label: `${emp.emp_id} - ${fullName}`,
                    empName: fullName,
                    address: emp.address,
                    pin: emp.pin,
                    state: emp.state,
                    city: emp.city
                }
            });
            setEmployeeList(formatted);
        } catch (err) {
            console.error('Error fetching employee data:', err);
        }
    }

    const fetchDisciplinaryWarning = async () => {
        setLoading(true);
        try {
            const res = await axios.get('https://api.skyguard.group/api/fetch-hrms-documents?doc_type=Disciplinary Warning');
            setDisciplinaryWarningList(res.data.result);
            // console.log(res.data.result);
        } catch (error) {
            console.error("Error fetching Disciplinary Warning", error);
        } finally {
            setLoading(false);
        }
    }

    useEffect(() => {
        fetchEmployeeData();
        fetchDisciplinaryWarning();
    }, [])

    return (
        <>
            <div className='main-section'>
                <div className='container-fluid dashboard-wrapper p-3 bg-body-secondary'>
                    <button
                        onClick={() => navigate('/admin/hrms-document')}
                        className="btn btn-dark border d-flex align-items-center gap-2 px-3 py-2 shadow-sm rounded-pill mb-3"
                    >
                        <IoArrowBack size={18} /> Back
                    </button>

                    <h3 className='my-3 fw-bold fs-5 golos'>Disciplinary Warning</h3>

                    <div className="mb-3 row gx-3 gy-2 align-items-center d-flex justify-content-between">
                        <div className="col-12 col-md-5">
                            <input
                                type="text"
                                className="form-control border-0 border-bottom border-dark"
                                placeholder="Search..."
                                value={searchTerm}
                                onChange={(e) => setSearchTerm(e.target.value)}
                            />
                        </div>
                        <div className="col-12 col-md-2 d-flex justify-content-end">
                            <button className='btn btn-success' onClick={handleFormOpen}>
                                <AiOutlinePlusCircle size={20} /> Add
                            </button>
                        </div>
                    </div>
                    {showForm && (
                        <div className='card p-3 my-3 shadow-sm bg-white border'>
                            <form onSubmit={handleSubmit}>
                                <div className='row'>
                                    {/* left side */}
                                    <div className='col-md-6'>
                                        <div className='row g-3'>
                                            {/* Employee id */}
                                            <div className="col-12">
                                                <label className="form-label fw-medium">Select Employee </label>
                                                <Select
                                                    options={employeeList}
                                                    onChange={(selectedOption) => {
                                                        setFormData(prev => ({
                                                            ...prev,
                                                            emp_db_id: selectedOption.id,
                                                            emp_id: selectedOption.value,
                                                            emp_name: selectedOption.empName,

                                                            address: selectedOption.address,
                                                            city: selectedOption.city,
                                                            state: selectedOption.state,
                                                            pin: selectedOption.pin
                                                        }))
                                                    }}
                                                    value={
                                                        employeeList.find(opt => String(opt.id) === String(formData.emp_db_id)) || null
                                                    }
                                                    required
                                                />
                                            </div>
                                            {/* from_date/period    */}
                                            <div className="col-12">
                                                <label htmlFor='from_date' className="form-label fw-medium">From Date</label>
                                                <input
                                                    type="date"
                                                    className="form-control"
                                                    name="from_date"
                                                    id='from_date'
                                                    value={formData.from_date}
                                                    onChange={handleChange}
                                                />
                                            </div>
                                            {/* Effect/Amount */}
                                            <div className="col-12">
                                                <div className='row g-2'>
                                                    <div className='col-md-6'>
                                                        <label htmlFor='prefix' className="form-label fw-medium">Effect</label>
                                                        <Select
                                                            options={effectOption}
                                                            value={effectOption.find(opt => opt.value === formData.effect) || null}
                                                            onChange={(selectedOption) => {
                                                                setFormData(prev => ({
                                                                    ...prev,
                                                                    effect: selectedOption ? selectedOption.value : ''
                                                                }));
                                                            }}
                                                        />
                                                    </div>
                                                    <div className='col-md-6'>
                                                        <label htmlFor='amount' className="form-label fw-medium">Amount</label>
                                                        <input
                                                            type="number"
                                                            className="form-control"
                                                            name="amount"
                                                            id='amount'
                                                            value={formData.amount}
                                                            onChange={handleChange}
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    {/* right-side */}
                                    <div className='col-md-6'>
                                        <div className='row g-3'>
                                            {/* Doc. Type */}
                                            <div className="col-12">
                                                <label htmlFor='doc_type' className="form-label fw-medium">Document Type</label>
                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    name="doc_type"
                                                    id='doc_type'
                                                    placeholder="Enter Name..."
                                                    value={formData.doc_type}
                                                    onChange={handleChange}
                                                    required
                                                    disabled
                                                />
                                            </div>
                                            {/* Prefix/Sufix */}
                                            <div className="col-12">
                                                <div className='row g-2'>
                                                    <div className='col-md-6'>
                                                        <label htmlFor='prefix' className="form-label fw-medium">Prefix</label>
                                                        <input
                                                            type="text"
                                                            className="form-control"
                                                            name="prefix"
                                                            id='prefix'
                                                            value={formData.prefix}
                                                            onChange={handleChange}
                                                            disabled
                                                        />
                                                    </div>
                                                    <div className='col-md-6'>
                                                        <label htmlFor='sufix' className="form-label fw-medium">Sufix</label>
                                                        <input
                                                            type="text"
                                                            className="form-control"
                                                            name="sufix"
                                                            id='sufix'
                                                            value={formData.sufix}
                                                            onChange={handleChange}
                                                            disabled
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className='row g-3 mt-2'>
                                        <div className='col-12'>
                                            <label htmlFor='warning_description' className="form-label fw-medium">Disciplinary Warning</label>
                                            <textarea
                                                className="form-control"
                                                name="warning_description"
                                                id='warning_description'
                                                placeholder="Enter here..."
                                                rows="12"
                                                value={formData.warning_description || ''}
                                                onChange={handleChange}
                                            />
                                        </div>
                                    </div>
                                </div>
                                {/* save/Cancel */}
                                <div className='d-flex justify-content-center mt-4 gap-2'>
                                    <button type='submit' className='btn btn-success'>
                                        {isEditing ? 'UPDATE' : 'SAVE'}
                                    </button>
                                    <button type='button' className='btn btn-danger'
                                        onClick={() => {
                                            resetForm();
                                        }}
                                    >
                                        Cancel
                                    </button>
                                </div>
                            </form>
                        </div>
                    )}
                    <div className='table-responsive shadow p-3 mb-5 bg-body-tertiary rounded my-4'>
                        <table className='table table-bordered table-striped text-center table-sm align-middle'>
                            <thead className='table-info'>
                                <tr>
                                    <th>SL</th>
                                    <th>Emp ID</th>
                                    <th>Emp Name</th>
                                    <th>Doc. Type</th>
                                    <th>Prefix</th>
                                    <th>Sufix</th>
                                    <th>Action</th>
                                </tr>
                            </thead>
                            <tbody>
                                {filteredData.length > 0 ? (
                                    filteredData.map((itm, idx) => (
                                        <tr key={idx}>
                                            <td>{idx + 1}</td>
                                            <td>{itm.emp_id}</td>
                                            <td>{itm.emp_name}</td>
                                            <td>{itm.doc_type}</td>
                                            <td>{itm.prefix}</td>
                                            <td>{itm.sufix}</td>
                                            <td>
                                                <button className='btn btn-sm btn-primary mx-1' onClick={() => handleEdit(itm.id)}><AiOutlineEdit size={18} /></button>
                                                <button className='btn btn-sm btn-danger mx-1'
                                                    // onClick={() => handleDelete(itm.id)}
                                                    onClick={() =>
                                                        showConfirmDialog({
                                                            title: 'Delete Salary Increment',
                                                            message: `Are you sure you want to delete ${itm.emp_name} Disciplinary Warning ?`,
                                                            onConfirm: () => handleDelete(itm.id),
                                                        })
                                                    }
                                                >
                                                    <AiOutlineDelete size={18} />
                                                </button>
                                                <button
                                                    className='btn btn-sm btn-secondary mx-1'
                                                    onClick={() => handlePrint(itm)}
                                                >
                                                    Print
                                                </button>
                                            </td>
                                        </tr>
                                    ))
                                ) : (
                                    <tr>
                                        <td colSpan="7" className="text-center text-danger fw-bold text-muted">No data found</td>
                                    </tr>
                                )}
                            </tbody>
                        </table>
                        {/* ====== PRINT LETTER FORMAT ====== */}
                        {selectedPrint && (
                            <div id="print-area" style={{ display: "none" }}>
                                <div
                                    style={{
                                        padding: "50px",
                                        fontFamily: "Times New Roman",
                                        lineHeight: "1.3",
                                        width: "800px",
                                        margin: "auto",
                                        background: "linear-gradient(to bottom, #f6f9ff, #eef3ff)",
                                        position: "relative",
                                    }}
                                >
                                    {/* ====== WATERMARK COMPANY LOGO ====== */}
                                    <img
                                        src={logo}
                                        alt="watermark"
                                        style={{
                                            position: "absolute",
                                            top: "50%",
                                            left: "50%",
                                            width: "350px",
                                            height: "350px",
                                            opacity: "0.08",
                                            transform: "translate(-50%, -50%)",
                                            zIndex: "0",
                                        }}
                                    />

                                    {/* CONTENT */}
                                    <div style={{ position: "relative", zIndex: "10" }}>
                                        <h2 style={{ textAlign: "center", marginBottom: "5px" }}>
                                            <u>Disciplinary Warning Letter</u>
                                        </h2>

                                        <div
                                            style={{
                                                display: "flex",
                                                justifyContent: "space-between",
                                                marginBottom: "20px",
                                            }}
                                        >
                                            <p><b>Ref No:</b> {selectedPrint.prefix}/{selectedPrint.sufix}/{selectedPrint.emp_id}</p>
                                            <p><b>Date:</b> {selectedPrint.from_date}</p>
                                        </div>

                                        <p>
                                            To,<br />
                                            <b>{selectedPrint.emp_name}</b><br />
                                            Employee ID: {selectedPrint.emp_id}<br />

                                            {selectedPrint.address || selectedPrint.city || selectedPrint.state || selectedPrint.pin ? (
                                                <>
                                                    {selectedPrint.address && (
                                                        <>
                                                            Address: {selectedPrint.address}<br />
                                                        </>
                                                    )}

                                                    {(selectedPrint.city || selectedPrint.pin) && (
                                                        <>
                                                            {(selectedPrint.city ? selectedPrint.city : "")}
                                                            {selectedPrint.pin ? ` - ${selectedPrint.pin}` : ""}
                                                            <br />
                                                        </>
                                                    )}

                                                    {selectedPrint.state && (
                                                        <>
                                                            {selectedPrint.state}<br />
                                                        </>
                                                    )}
                                                </>
                                            ) : (
                                                <>
                                                    Address: Not Available<br />
                                                </>
                                            )}
                                        </p>

                                        <p><b>Dear {selectedPrint.emp_name?.split(" ")[0]},</b></p>

                                        {/* ====== MAIN WARNING CONTENT ====== */}
                                        <p style={{ textAlign: "justify" }}>
                                            This is to formally bring to your attention a matter of serious concern regarding your recent
                                            conduct and performance at the workplace. After careful review, it has been observed that:
                                        </p>
                                        <p
                                            style={{
                                                textAlign: "justify",
                                                whiteSpace: "pre-line",
                                                fontWeight: "bold",
                                                margin: "15px 0",
                                                fontSize: "13px"
                                            }}
                                        >
                                            {selectedPrint.warning_description || "No description provided."}
                                        </p>

                                        <p style={{ textAlign: "justify" }}>
                                            This behavior is considered unacceptable and is in violation of company policies. You are hereby
                                            issued an official warning and are advised to take immediate corrective measures.

                                            Any repetition of such behavior or failure to show improvement may result in further disciplinary
                                            action, which may include suspension or termination of employment.
                                        </p>

                                        <br />

                                        <p>
                                            We expect you to treat this matter seriously and bring about the necessary improvements promptly.
                                        </p>

                                        <br />

                                        <p>
                                            With Regards,<br /><br />
                                            <b>For Star Signature Services</b><br /><br />
                                            Authorized Signatory
                                        </p>

                                        <p style={{ marginTop: "50px" }}>
                                            I acknowledge and accept this warning letter.<br /><br />
                                            SIGNATURE: ({selectedPrint.emp_name}) <br />
                                            Date: ___________
                                        </p>
                                    </div>
                                </div>
                            </div>
                        )}

                    </div>
                </div>
            </div>

            <ToastNotification
                show={toast.show}
                message={toast.message}
                bg={toast.bg}
                onClose={() => setToast({ ...toast, show: false })}
            />
            <ConfirmDialog
                show={confirmDialog.show}
                title={confirmDialog.title}
                message={confirmDialog.message}
                onConfirm={confirmDialog.onConfirm}
                onCancel={() => setConfirmDialog({ ...confirmDialog, show: false })}
            />
        </>
    )
}

export default DisciplinaryWarning
